<template>
  <div class="mall-list-index">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" ></Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #happayOrganizationId="{ row }">{{ row.happayOrganizationId }}</template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #workTime="{ row }">{{ row.workTime || '---' }}</template>
      <template #address="{ row }">{{ row.address }}</template>
      <template #operation="{ scope }">
        <el-button type="text" @click="currentMall = scope.row" >修改组织ID</el-button >
      </template>
    </Table>
    <Dialog :maskClose="false" :dialogShow="!!currentMall" title="修改组织ID" @maskClick="currentMall = null">
      <el-form :hide-required-asterisk="true" ref="editForm" :model="editForm" label-width="100px">
        <el-form-item label="商场名称" >
          <span>{{ currentMall ? currentMall.name : '' }}</span>
        </el-form-item>
        <el-form-item label="原组织ID" >
          <span>{{ currentMall ? currentMall.happayOrganizationId : '' }}</span>
        </el-form-item>
        <el-form-item :rules="[{ required: true, message: '请输入新组织ID'},]" label="新组织ID" prop="organizationId">
          <el-input placeholder="请输入新组织ID" v-model.trim="editForm.organizationId" type="text"></el-input>
        </el-form-item>
      </el-form>
      <el-row class="button-box">
        <el-button type="default" class="cancel mr20" @click="() => {this.currentMall = null}">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click="editSubmit">确定</el-button>
      </el-row>
    </Dialog>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import Dialog from "@/components/Dialog/index";
import { api_getMallList, api_putMallEdit } from '@/api/mall'

export default {
  name: "mallIndex",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
    Dialog
  },
  data() {
    return {
      renderData: [
        {
          label: "商场名称",
          placeholder: "请输入商场名称",
          type: "input",
          key: "name",
        },
      ],
      form: {},
      tableThData: [
        { prop: "happayOrganizationId", label: "组织ID", minWidth: "100", },
        { prop: "name", label: "商场名称", minWidth: "130", },
        { prop: "workTime", label: "营业时间", minWidth: "120", },
        { prop: "address", label: "地址", minWidth: "150", },
        { prop: "operation", label: "操作", minWidth: "100", },
      ],
      currentMall: null,
      editForm: {},
      editLoading: false
    };
  },
  created() {},
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      const data = await api_getMallList(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },

    // 编辑
    editSubmit() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          let params = {
            ...this.editForm,
            mallId: this.currentMall.id
          }
          console.log('params: ', params);
          await api_putMallEdit(params)
          this.$baseMessage('操作成功', 'success')
          this.currentMall = null
          this.editForm = {}
          this.getList()
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.mall-list-index {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;

  .Dialog {
    // position: relative;
    .el-form {
      padding-top: 20px;
    }

    .button-box {
      position: absolute;
      bottom: 20px;
      right: 40px;
    }
  }
}
</style>
